var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaverpostHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3FC73C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2.5v12h12v-12h-12zm9 8.74h-2.04L11.52 8.4v2.84H9.5v-5.5h2.04l1.94 2.84V5.74h2.02v5.5zM15.92 18.662H9.08L6.5 15.679h12l-2.58 2.983zM14.9 19.84l-2.4 2.775-2.4-2.775h4.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverpostHover);
export default __webpack_public_path__ + "static/media/naverpostHover.177e56f9dff052f0f46ce976ee4a6ceb.svg";
export { ForwardRef as ReactComponent };